import { Component } from '@angular/core';

@Component({
  selector: 'app-road-exit-portal',
  templateUrl: './road-exit-portal.component.html',
  standalone: false,
})
export class RoadExitPortalComponent {}
